import React from "react"
import { useHistory } from "react-router-dom"

import {
  NotificationDetailActionButton,
} from "@/components/Notifications/NotificationDetailActionButton"
import { NOTIFICATION_DETAIL_BODY_CLASS } from "@/constants/notificationDetailChrome"
import { cn } from "@/lib/utils"
import {
  isNotificationActionUrlKey,
  isNotificationReportsUrlKey,
  isNotificationTradeReviewUrlKey,
  resolveNotificationInternalPath,
  resolveNotificationReportsWizardPath,
} from "@/utils/notificationDetailNavigation"

function formatDetailValue(value: unknown): string {
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return String(value)
  }
  if (value == null) return "—"
  return JSON.stringify(value)
}

export function NotificationDetailValueCell({
  fieldKey,
  value,
}: {
  fieldKey: string
  value: unknown
}): React.ReactElement {
  const history = useHistory()

  if (isNotificationActionUrlKey(fieldKey)) {
    const path = resolveNotificationInternalPath(
      typeof value === "string" ? value : ""
    )
    if (!path) {
      return <span className={NOTIFICATION_DETAIL_BODY_CLASS}>—</span>
    }

    return (
      <NotificationDetailActionButton
        label="View statistics"
        dataAttr="statistics"
        variant="outline-brand"
        onClick={() => history.push(path)}
      />
    )
  }

  if (isNotificationTradeReviewUrlKey(fieldKey)) {
    const path = resolveNotificationInternalPath(
      typeof value === "string" ? value : ""
    )
    if (!path) {
      return <span className={NOTIFICATION_DETAIL_BODY_CLASS}>—</span>
    }

    return (
      <NotificationDetailActionButton
        label="Open trade review"
        dataAttr="trade-review"
        variant="outline-gray"
        onClick={() => history.push(path)}
      />
    )
  }

  if (isNotificationReportsUrlKey(fieldKey)) {
    const path = resolveNotificationReportsWizardPath(
      typeof value === "string" ? value : ""
    )
    if (!path) {
      return <span className={NOTIFICATION_DETAIL_BODY_CLASS}>—</span>
    }

    return (
      <NotificationDetailActionButton
        label="Generate report"
        dataAttr="reports"
        onClick={() => history.push(path)}
      />
    )
  }

  return (
    <span className={cn(NOTIFICATION_DETAIL_BODY_CLASS, "break-all")}>
      {formatDetailValue(value)}
    </span>
  )
}
